<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <div class="slogn-btn" @click="goUrl()"></div>
    </div>
    <div class="mod-nav">
      <div class="con">
        <span v-for="(nav, index) in navList" :key="index" :class="{cur: navIndex === index}" @click="changeIndex(index)">{{nav}}</span>
      </div>
    </div>
    <div class="banner">
      <div class="con">
        <el-carousel height="580px" @change="getIndex" ref="bannerCarousel1" :interval="5000" arrow="never" indicator-position="none">
          <el-carousel-item v-for="item in bannerList1" :key="item.imgSrc">
            <h2>{{item.title}}</h2>
            <div class="item-con">
              <img :src="item.imgSrc" />
              <div class="info">
                <h3>{{item.summary1}}</h3>
                <p>{{item.summary2}}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="buy-btn" @click="goUrl()">立即解锁超级盯盘></div>
    <div class="mod2">
      <img src="../../assets/images/activity/activity202305/title2.png" alt="">
      <div class="banner">
        <div class="con">
          <el-carousel height="550px" ref="bannerCarousel2" :interval="3000" arrow="never" indicator-position="none">
            <el-carousel-item v-for="item in bannerList2" :key="item.imgSrc">
              <img :src="item.imgSrc" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <span class="arrow arrow-l" @click="changePrev"></span>
        <span class="arrow arrow-r" @click="changeNext"></span>
      </div>
    </div>
    <div class="mod-footer">
      <div class="con">
        <h3>关于大智慧「金融信息终端」</h3>
        <h4>「金融信息终端」是大智慧全新打造的新一代智能投研平台，汇聚大智慧20年高端产品优势。<br>涵盖“全景盯盘”、“决策链选股”、“全链预警”、“量化投研”、“研究员服务”等独家高端实用功能，<br>全方位辅助专业交易用户的投研决策。</h4>
        <p>投资有风险，入市需谨慎</p>
      </div>
    </div>
    <div class="pop-bg" v-show="isPop" @click="isPop = false">
      <div class="pop-con" @click.stop="isPop = true">
        <span class="close" @click.stop="isPop = false"></span>
        <h2>当日优惠名额已达上限<br>请明日再来</h2>
        <p>详情咨询客服：<em>021-20219999</em></p>
        <span class="btn" @click.stop="isPop = false">确定</span>
      </div>
    </div>
  </div>
</template>
<script>
</script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      navIndex: 0,
      navList: ['全景盯盘', '决策链选股', '全链预警', '量化投研', '研究员服务'],
      bannerList1: [
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner1-1.jpg'),
          title: '全景盯盘-全方位评测手中个股',
          summary1: '技术面、资金面、基本面、消息面，四维一体',
          summary2: '全方位综合评测手中个股，轻松锁定高评分、强势个股。'
        },
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner1-2.jpg'),
          title: '决策链选股-技术面选股利器',
          summary1: '强势个股千里挑一',
          summary2: '结合技术形态、指标共振、多周期强势、预计机会风险比等智能筛选强势个股。'
        },
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner1-3.jpg'),
          title: '全链预警-全面揭露行业重大信息',
          summary1: '财经消息利好、利空一目了然',
          summary2: '全面揭露企业、行业重大信息（公司舆情、产业舆情）；企业链、产业链图谱助力热点炒作。'
        },
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner1-4.jpg'),
          title: '量化投研-高手热门策略免费分享',
          summary1: '优质策略广场、专属量化策略',
          summary2: '实时追踪、免费订阅专业机构及交易高手潜心自研的「独家量化策略」，1分钟构建“专属量化策略”'
        },
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner1-5.jpg'),
          title: '研究员服务-全行业覆盖，实时答疑解惑',
          summary1: '大智慧金融信息研究院',
          summary2: '提供机构监控报告（券商月度金股、券商策略周报、机构调研监控等）、直播路演、线上实时答疑等高端用户专属服务。'
        },
      ],
      bannerList2: [
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner2-1.jpg'),
        },
        {
          imgSrc: require('../../assets/images/activity/activity202305/banner2-2.jpg'),
        },
      ],
      isPop: false
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    this.productClick()
  },
  methods: {
    // 335双周卡统计
    productClick () {
      var params =  {
        id : 335,
        num:  14,
        dateUnit: 'day',
        source: 'pc_baidu'
      }
      var userName = this.$storage.getUserName()
      if (!userName) return
      this.$post('/product/productClick', params)
        .then(res =>{
          // console.log(res)
        })
    },
    goUrl () {
      let routerDate = this.$router.resolve({name: 'OrderConfirm335', params:{month: '14d'}})
      let {href} = routerDate
      window.open(href, "_blank")
    },
    changeIndex (val) {
      this.navIndex = val
      this.$refs.bannerCarousel1.setActiveItem(val)
    },
    getIndex(val) {
      this.navIndex = val
    },
    changePrev() {
      this.$refs.bannerCarousel2.prev()
    },
    changeNext() {
      this.$refs.bannerCarousel2.next()
    }
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/activity202305/bg1.jpg) no-repeat center 100px #fff3f3;
  .auto{
    width: 1100px;
    margin: 0px auto 0px;
    position: relative;
    padding-top: 903px;
  }
  .slogn-btn{
    position: absolute;
    right: 50px;
    top: 495px;
    background: url(../../assets/images/activity/activity202305/btn.png) no-repeat;
    width: 281px;
    height: 109px;
    -webkit-animation: bigger 1.5s linear infinite;
    animation: bigger 1.5s linear infinite;
    cursor: pointer;
  }
  .mod-nav{
    height: 63px;
    border-bottom: 2px solid #eb1a15;
    .con{
      width: 1100px;
      margin: 20px auto 55px;
      display: flex;
      justify-content: space-between;
    }
    span{
      width: 200px;
      height: 63px;
      background: linear-gradient(to bottom, #ff7c61, #ea1712);
      color: #ffffff;
      font-size: 35px;
      text-align: center;
      line-height: 63px;
      border-radius: 20px 20px 0 0;
      cursor: pointer;
      &.cur{
        background: #f6d208;
        color: #ea1915;
      }
    }
  }
  .banner{
    width: 1114px;
    height: 722px;
    margin: 54px auto 48px;
    padding: 122px 60px 0;
    background: url(../../assets/images/activity/activity202305/mod-bg2.png) no-repeat;
    h2{
      font-size: 40px;
      color: #ea1915;
      text-align: center;
      margin-bottom: 50px;
    }
    .item-con{
      display: flex;
      justify-content: space-between;
      font-size: 30px;
      .info{
        width: 337px;
        padding-top: 30px;
      }
      h3{
        color: #964b02;
        margin-bottom: 30px;
      }
      p{
        color: #353535;
      }
    }
  }
  .buy-btn{
    width: 702px;
    height: 106px;
    background:linear-gradient(to bottom, #ff5251, #ee2a22);
    box-shadow: 0 12px 18px rgba($color: #ff5753, $alpha: 0.55);
    border-radius: 60px;
    font-size: 40px;
    color: #fff;
    text-align: center;
    line-height: 106px;
    margin: 0 auto 84px;
    -webkit-animation: bigger 1.5s linear infinite;
    animation: bigger 1.5s linear infinite;
    cursor: pointer;
  }
  .mod2{
    background: #fff;
    padding: 60px 0 88px;
    >img{
      display: block;
      margin: 0 auto 20px;
    }
    .banner{
      margin: 0 auto;
      padding-top: 160px;
      position: relative;
      .arrow{
        width: 110px;
        height: 110px;
        position: absolute;
        top: 300px;
        cursor: pointer;
      }
      .arrow-l{
        background: url(../../assets/images/activity/activity202305/arrow-left.png) no-repeat;
        left: -60px;
      }
      .arrow-r{
        background: url(../../assets/images/activity/activity202305/arrow-right.png) no-repeat;
        right: -60px;
      }
    }
  }
  .mod-footer{
    background: url(../../assets/images/activity/activity202305/bg2.jpg) no-repeat #c7191d;
    height: 300px;
    padding-top: 50px;
    .con{
      margin: 0 auto;
      width: 1000px;
      h3{
        color: #ffd800;
        font-size: 34px;
      }
      h4{
        font-size: 22px;
        color: #fff;
        margin: 15px 0 25px;
        line-height: 36px;
      }
      p{
        font-size: 15px;
        color: #fff;
        opacity: 0.3;
        text-align: center;
      }
    }
  }
  .pop-bg{
    background: rgba($color: #000000, $alpha: 0.3);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    .pop-con{
      width: 400px;
      background: #fff;
      border: 5px solid #f1441a;
      border-radius: 20px;
      position: absolute;
      left: 50%;
      margin-left: -200px;
      top: 35%;
      padding: 40px 40px 40px;
      h2{
        color: #232323;
        font-size: 29px;
        font-weight: bold;
        text-align: center;
        line-height: 50px;
      }
      p{
        font-size: 22px;
        color: #393939;
        margin: 15px 0 25px;
        em{
          color: #0072ff;
        }
      }
      .btn{
        height: 51px;
        line-height: 51px;
        text-align: center;
        display: block;
        width: 100%;
        background: linear-gradient(to right, #f1441b, #ff7574);
        border-radius: 20px;
        font-size: 22px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .close{
    width: 47px;
    height: 47px;
    display: block;
    position: absolute;
    top: -15px;
    right: -12px;
    background: url(../../assets/images/activity/activity202305/close.png) no-repeat;
    cursor: pointer;
  }
}
 @keyframes bigger {
  0%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  50%{
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202305.vue